import useModal from '@fipnooone/react-modal';
import cn from 'classnames';
import { FC, useMemo } from 'react';

import { ModalInfo } from '@/Components/Modal/Dialogs';
import { Button, Icon } from '@/Components/UI';
import { lineWrap } from '@/Services/Tools/string';

import { NotificationCardProps } from './NotificationCard.types';
import S from './styles.module.scss';

export const NotificationCard: FC<NotificationCardProps> = ({ notification, onClick }) => {
    const [modal, modalControls] = useModal();

    const statusIcon = useMemo(() => {
        switch (notification.status) {
            case 'success':
                return <Icon name="green-checkmark" size={20} />;
            case 'warning':
                return <Icon name="warning" size={20} />;
            case 'critical':
                return <Icon name="red-warning" size={20} />;
        }
    }, [notification.status]);

    const handleClick = () => {
        if (!notification.description) {
            return;
        }

        modalControls.set(<ModalInfo children={<p className={S.notification_content}>{lineWrap(notification.description)}</p>} />);
    };

    return (
        <div onClick={onClick} className={cn(S.notification, { [S['notification-read']]: notification.is_read })}>
            <div className={S.notification_top}>
                <div className={S.notification_status}>Status: {statusIcon}</div>
                <div className={S.notification_date}>{notification.created_at}</div>
            </div>
            <div className={S.notification_content}>{lineWrap(notification.content)}</div>
            {!!notification.description && (
                <>
                    <Button type="button" onClick={handleClick} className={S.notification_button}>
                        Description
                    </Button>
                    {modal}
                </>
            )}
        </div>
    );
};
